import { gsap } from 'gsap';
import { breakpoints, isTabletDown } from './isMobile';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { DrawSVGPlugin } from '../greensock/DrawSVGPlugin';
import { SnapperInstance } from './snapper';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

var searchContainer = $('#search-container');
var searchInput = searchContainer.find('input');
var searchOverlay = $('#search-overlay');
var scroller = $('#content');
var tl = gsap.timeline({
    paused: true,
    onStart: function () {
        searchInput.val('');
    },
    onComplete: function () {
        searchInput.focus();
    }
})
    .to(searchContainer.find('form'), .6, { width: 220 })
    .to(searchOverlay, .6, { delay: -.6, autoAlpha: 1 });
var open = false;
searchContainer
    .on('submit', function (event) {
        if (!open) {
            event.preventDefault();
            open = true;
            tl.play();
        }
        else {
            tl.reverse();
        }
    });
searchInput
    .on('blur', function () {
        open = false;
        tl.reverse();
    });
if (scroller.length) {
    var settings = {};
    var desktopSettings = function () {
        gsap.timeline({
            scrollTrigger: {
                trigger: scroller.find('> *:first-child'),
                scroller: scroller,
                start: 0,
                end: 100,
                scrub: true
            }
        })
            .to('.header__banner', 1, { height: 0 })
            .to('.header__container .grid-container', 1, { height: '7rem' })
            .to('.header__logo', 1, { marginTop: '-=1.125rem' }, '-=1');
    }
    var mobileSettings = function () {
        gsap.timeline({
            scrollTrigger: {
                trigger: scroller.find('> *:first-child'),
                scroller: scroller,
                start: 0,
                end: 100,
                scrub: true
            }
        })
            .to('.header__banner', 1, { height: 0 })
            .to('.header__container .grid-container', 1, { height: '5.688rem' })
            .to('.header__logo', 1, { marginTop: '-=1.125rem' }, '-=1');
    }
    settings[breakpoints.desktop] = desktopSettings;
    settings[breakpoints.mobile] = mobileSettings;
    settings[breakpoints.tablet] = desktopSettings;
    ScrollTrigger.matchMedia(settings);
}

var header = document.querySelector('.header');
var subMenus = document.querySelectorAll('.header__middle > nav > ul > li');

subMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
        menu.classList.add('active');
        var navbar = menu.querySelector('.header__navbar');
        var navbarItem = navbar.querySelector('.header__navbar-item');
        SnapperInstance.lock();
        var height = Math.min(navbarItem.clientHeight + 112, document.body.clientHeight - header.clientHeight - 16);
        if (height < navbarItem.clientHeight + 112) {
            gsap.set(navbar, {
                overflowY: 'auto',
                overflowX: 'hidden'
            });
            height = Math.min(navbarItem.clientHeight + 112, document.body.clientHeight - header.clientHeight - 16);
        }
        menu._timeline = gsap.timeline()
            .to(navbar, {
                duration: .3,
                autoAlpha: 1,
                height: height,
                paddingTop: 56,
                paddingBottom: 56,
                onReverseComplete: () => {
                    menu.classList.remove('active');
                    gsap.set(navbar, {
                        clearProps: 'all'
                    });
                }
            });
    });
    menu.addEventListener('mouseleave', () => {
        SnapperInstance.unlock();
        menu._timeline.reverse();
    });
});

document.fonts.ready.then(function () {
    subMenus.forEach(menu => {
        menu.querySelector('.spacer').style.width = menu.clientWidth + 'px';
    });
});

var donateButtons = document.querySelectorAll('.header .btn-donate');
donateButtons.forEach(button => {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var radius = button.clientHeight / 2 + 2;
    var innerRadius = radius - 1;
    button._previousWidth = button.clientWidth;
    var width = button.clientWidth + 4;
    var height = button.clientHeight + 4;
    svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute('d',
        `M ${radius} 1 L ${width - radius} 1 A ${innerRadius} ${innerRadius} 180 0 1 ${width - radius} ${height - 1} L ${radius} ${height - 1} A ${innerRadius} ${innerRadius} 180 0 1 ${radius} 1 Z`
    )
    var path2 = path.cloneNode();
    svg.appendChild(path);
    svg.appendChild(path2);
    button.append(svg);
    button._timeline = gsap.timeline({
        repeat: -1
    })
        .fromTo(path, { drawSVG: '0% 25%' }, { duration: 2.1, drawSVG: '75% 100%', ease: 'linear' })
        .to(path, { duration: .7, drawSVG: '100% 100%', ease: 'linear' })
        .fromTo(path2, { drawSVG: '0%' }, { duration: .7, drawSVG: '0 25%', ease: 'linear' }, '-=.7');
});

var resizeTimeout;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        donateButtons.forEach(button => {
            if (button._previousWidth !== button.clientWidth) {
                button._timeline.kill();
                var svg = button.querySelector('svg');
                var radius = button.clientHeight / 2 + 2;
                var innerRadius = radius - 1;
                button._previousWidth = button.clientWidth;
                var width = button.clientWidth + 4;
                var height = button.clientHeight + 4;
                svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
                var paths = svg.querySelectorAll('path');
                gsap.set(paths, { clearProps: 'all' });
                paths.forEach(path => {
                    path.setAttribute('d',
                        `M ${radius} 1 L ${width - radius} 1 A ${innerRadius} ${innerRadius} 180 0 1 ${width - radius} ${height - 1} L ${radius} ${height - 1} A ${innerRadius} ${innerRadius} 180 0 1 ${radius} 1 Z`
                    )
                });
                button._timeline = gsap.timeline({
                    repeat: -1
                })
                    .fromTo(paths[0], { drawSVG: '0% 25%' }, { duration: 2.1, drawSVG: '75% 100%', ease: 'linear' })
                    .to(paths[0], { duration: .7, drawSVG: '100% 100%', ease: 'linear' })
                    .fromTo(paths[1], { drawSVG: '0%' }, { duration: .7, drawSVG: '0 25%', ease: 'linear' }, '-=.7');
            }
        })

    }, 100);
})